var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useCallback } from 'react';
import { usePromiseDoingCallback } from '@/hooks/async/loading/usePromiseDoingCallback';
import { wrapDispatch } from '@/utils/actions/dispatch';
import { isSucceededPayload } from '@/utils/actions/payload';
import { useSessionStorage } from '@/utils/libs/react-hookz/useSessionStorage';
/**
 * マスタ系データ取得用の汎用的なuse
 *
 * @summary useSessionStorageを利用しつつ、データ/取得用の関数/ローディング状態などを返す。主にマスタ系、頻繁に参照しない件数取得系のapiを取得する際に利用する
 * @param args
 */
export const useSessionStorageAction = (args) => {
    const { apiAction, apiActionData, apiActionMeta, dispatch, sessionStorageKey, unmountRef, } = args;
    // session storage経由でデータを保存するためのstate
    const { set: setData, value: data } = useSessionStorage(sessionStorageKey, {
        defaultValue: null,
    });
    /**
     * データ取得
     */
    const fetchDataBase = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const { payload } = yield wrapDispatch(dispatch, apiAction(apiActionData || {}, apiActionMeta || {}));
            if (isSucceededPayload(payload)) {
                setData(payload);
            }
        }
        catch (error) {
            // eslint-disable-next-line no-console
            console.error(error);
        }
    }), [apiAction, apiActionData, apiActionMeta, dispatch, setData]);
    // データ取得のローディング制御
    const { callbackPromiseEvent: fetchData, doing: isLoading } = usePromiseDoingCallback({
        promiseEvent: fetchDataBase,
        unmountRef,
    });
    return {
        data: data !== null && data !== void 0 ? data : null,
        fetchData,
        hasInitialData: data !== null,
        isLoading,
    };
};
